import ClipboardCopy from "clipboard-copy";

export default {
  copy(text: string) {
    return ClipboardCopy(text);
  }
};
